import type { ChangeEmitter } from '@/application/ChangeEmitter';
import type { I2DEngine } from '@/application/ports/I2DEngine';
import type { IViewportEngine2D } from '@/application/ports/IViewportEngine2D';

class ViewportController {
    constructor(
        private readonly _engine: I2DEngine,
        private readonly _viewportEngine: IViewportEngine2D,
        _changeEmitter: ChangeEmitter,
    ) {
        void _changeEmitter;
    }

    displayFullCanvasImage(): void {
        this._viewportEngine.displayFullCanvasImage();
        this._engine.dispatchZoomChanged(this._viewportEngine.getZoom());
    }

    getCanvasClientRect(): { height: number; width: number } {
        return this._viewportEngine.getCanvasClientRect();
    }

    getViewportTransform(): { scaleX: number; scaleY: number; translateX: number; translateY: number } {
        return this._viewportEngine.getViewportTransform();
    }

    getDefaultZoom(): number {
        return this._viewportEngine.getDefaultZoom();
    }

    getZoom(): number {
        return this._viewportEngine.getZoom();
    }

    onAfterRender(callback: () => void): () => void {
        return this._viewportEngine.onAfterRender(callback);
    }

    onZoomChanged(callback: (zoom: number) => void): () => void {
        return this._viewportEngine.onZoomChanged(callback);
    }

    resize(width: number, height: number): void {
        this._viewportEngine.resize(width, height);
    }

    // Reports the applied zoom, not the requested one — zoomTo clamps, so
    // dispatching the argument would show a value the canvas never reached.
    zoomTo(zoom: number): void {
        this._viewportEngine.zoomTo(zoom);
        this._engine.dispatchZoomChanged(this._viewportEngine.getZoom());
    }

    zoomToFit(): void {
        this._viewportEngine.displayFullCanvasImage();
        this._engine.dispatchZoomChanged(this._viewportEngine.getZoom());
    }
}

export { ViewportController };
